<div class="w-full">
    <a class="mb-2 inline-flex items-center gap-1 text-sm font-semibold text-slate-500 no-underline hover:text-primary"
       [routerLink]="['/companies/subscriptions']" [queryParams]="category?.seasonId ? {seasonId: category?.seasonId} : null">
        <i class="bi bi-arrow-left" aria-hidden="true"></i>
        Iscrizioni
    </a>

    <header class="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div class="min-w-0 flex-[1_1_18rem]">
            <ng-container *ngIf="!loading || category; else titleSkeleton">
                <p *ngIf="parentName" class="m-0 text-xs font-bold uppercase tracking-wide text-slate-400">{{ parentName }}</p>
                <h1 class="m-0 text-xl font-bold leading-7 text-slate-900">{{ category?.name || 'Categoria' }}</h1>
                <p *ngIf="category" class="m-0 mt-1 text-sm text-slate-500">
                    Quota {{ formatEuro(category.fullPrice) }}
                    <ng-container *ngIf="category.reducedPrice !== category.fullPrice">· ridotta {{ formatEuro(category.reducedPrice) }}</ng-container>
                </p>
                <button *ngIf="nextConvocation as next" type="button"
                        class="mt-2.5 inline-flex max-w-full items-center gap-1.5 rounded-full border-0 bg-primary-soft px-3 py-1 text-xs font-semibold text-primary transition hover:brightness-95"
                        (click)="tab = 'convocations'; convocationPeriod = 'upcoming'; expandedConvocationId = next.id">
                    <i class="bi bi-megaphone" aria-hidden="true"></i>
                    <span class="truncate">Prossima convocazione: {{ next.title }} · {{ convocationRelative(next) }}</span>
                </button>
            </ng-container>
            <ng-template #titleSkeleton>
                <span class="mb-2 block h-3 w-28 animate-pulse rounded bg-slate-100"></span>
                <span class="mb-2 block h-6 w-48 animate-pulse rounded bg-slate-100"></span>
                <span class="block h-4 w-36 animate-pulse rounded bg-slate-100"></span>
            </ng-template>
        </div>

        <div class="flex flex-wrap items-center gap-3">
            <select *ngIf="siblings.length > 1" class="form-select form-select-solid !w-auto min-w-[14rem]"
                    aria-label="Cambia categoria"
                    [ngModel]="category?.id" (ngModelChange)="goToCategory($event)">
                <option *ngFor="let sibling of siblings" [ngValue]="sibling.id">{{ sibling.name }}</option>
            </select>
            <button *ngIf="tab === 'athletes'" type="button" class="btn welldone-btn-gray inline-flex items-center gap-1.5"
                    [disabled]="loading || !filteredEnrollments.length" (click)="exportCsv()">
                <i class="bi bi-download" aria-hidden="true"></i>
                Esporta CSV
            </button>
        </div>
    </header>

    <div *ngIf="!loading && loadError"
         class="flex flex-col items-center rounded-2xl border-2 border-dashed border-slate-200 px-6 py-12 text-center">
        <i class="bi bi-exclamation-triangle mb-3 text-4xl text-amber-500" aria-hidden="true"></i>
        <h3 class="m-0 text-base font-bold text-slate-900">Impossibile caricare la categoria</h3>
        <p class="mb-5 mt-1.5 max-w-md text-sm text-slate-500">La categoria potrebbe essere stata eliminata, oppure c'è un problema di connessione.</p>
        <a class="btn btn-primary" [routerLink]="['/companies/subscriptions']">Torna alle iscrizioni</a>
    </div>

    <ng-container *ngIf="loading || !loadError">
        <!-- KPIs -->
        <section class="mb-6 grid grid-cols-2 gap-4 lg:grid-cols-4" aria-label="Riepilogo">
            <ng-container *ngIf="!loading; else kpiSkeleton">
                <div class="flex min-w-0 flex-col gap-1 rounded-2xl border border-slate-100 bg-white px-5 py-4 shadow-sm">
                    <span class="text-xs font-bold uppercase tracking-wide text-slate-500">Iscritti</span>
                    <strong class="text-2xl font-bold tabular-nums text-slate-900">{{ stats.total }}</strong>
                    <div class="mt-1 flex h-1.5 overflow-hidden rounded-full bg-slate-100">
                        <span class="h-full bg-emerald-500" [style.width.%]="percent(stats.paid, stats.total)"></span>
                        <span class="h-full bg-amber-500" [style.width.%]="percent(stats.verifyingPayment, stats.total)"></span>
                        <span class="h-full bg-red-500" [style.width.%]="percent(stats.pendingPayment, stats.total)"></span>
                    </div>
                </div>
                <div class="flex min-w-0 flex-col gap-1 rounded-2xl border border-slate-100 bg-white px-5 py-4 shadow-sm">
                    <span class="text-xs font-bold uppercase tracking-wide text-slate-500">Incassato</span>
                    <strong class="text-2xl font-bold tabular-nums text-slate-900">{{ formatEuro(stats.collected) }}</strong>
                    <span class="truncate text-xs text-slate-400">su {{ formatEuro(stats.expected) }} previsti</span>
                </div>
                <div class="flex min-w-0 flex-col gap-1 rounded-2xl border px-5 py-4 shadow-sm"
                     [ngClass]="stats.verifyingPayment ? 'border-amber-200 bg-amber-50' : 'border-slate-100 bg-white'">
                    <span class="text-xs font-bold uppercase tracking-wide text-slate-500">Da verificare</span>
                    <strong class="text-2xl font-bold tabular-nums text-slate-900">{{ stats.verifyingPayment }}</strong>
                    <span class="truncate text-xs text-slate-400">{{ stats.pendingPayment }} ancora in attesa di pagamento</span>
                </div>
                <div class="flex min-w-0 flex-col gap-1 rounded-2xl border border-slate-100 bg-white px-5 py-4 shadow-sm">
                    <span class="text-xs font-bold uppercase tracking-wide text-slate-500">Non tesserati</span>
                    <strong class="text-2xl font-bold tabular-nums text-slate-900">{{ stats.withoutMembership }}</strong>
                    <span class="truncate text-xs text-slate-400">Tesseramento mancante o scaduto</span>
                </div>
            </ng-container>
            <ng-template #kpiSkeleton>
                <div *ngFor="let i of [1, 2, 3, 4]" class="flex flex-col gap-2 rounded-2xl border border-slate-100 bg-white px-5 py-4 shadow-sm">
                    <span class="h-3 w-20 animate-pulse rounded bg-slate-100"></span>
                    <span class="h-7 w-14 animate-pulse rounded bg-slate-100"></span>
                    <span class="h-3 w-32 animate-pulse rounded bg-slate-100"></span>
                </div>
            </ng-template>
        </section>

        <!-- Tabs -->
        <div class="mb-5 flex gap-1 border-b border-slate-200" role="tablist">
            <button type="button" role="tab" [attr.aria-selected]="tab === 'athletes'"
                    class="-mb-px inline-flex items-center gap-2 border-0 border-b-2 bg-transparent px-4 py-2.5 text-sm font-semibold transition"
                    [ngClass]="tab === 'athletes' ? 'border-primary text-primary' : 'border-transparent text-slate-500 hover:text-slate-800'"
                    (click)="tab = 'athletes'">
                <i class="bi bi-people" aria-hidden="true"></i>
                Atleti
                <span class="rounded-full bg-slate-100 px-2 py-0.5 text-xs tabular-nums text-slate-600">{{ loading ? '…' : stats.total }}</span>
            </button>
            <button type="button" role="tab" [attr.aria-selected]="tab === 'convocations'"
                    class="-mb-px inline-flex items-center gap-2 border-0 border-b-2 bg-transparent px-4 py-2.5 text-sm font-semibold transition"
                    [ngClass]="tab === 'convocations' ? 'border-primary text-primary' : 'border-transparent text-slate-500 hover:text-slate-800'"
                    (click)="tab = 'convocations'">
                <i class="bi bi-megaphone" aria-hidden="true"></i>
                Convocazioni
                <span class="rounded-full bg-slate-100 px-2 py-0.5 text-xs tabular-nums text-slate-600">{{ loadingConvocations ? '…' : convocations.length }}</span>
            </button>
        </div>

        <ng-container *ngIf="tab === 'athletes'">
        <!-- Filters -->
        <div class="mb-4 flex flex-wrap items-center gap-3">
            <input type="search" class="form-control form-control-solid !w-auto min-w-[12rem] flex-[1_1_16rem]"
                   placeholder="Cerca nome, codice fiscale, email o telefono" [(ngModel)]="search" [disabled]="loading">
            <div class="flex flex-wrap gap-2" role="group" aria-label="Filtra per stato">
                <button type="button"
                        class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold transition"
                        [ngClass]="statusFilter === 'all' ? 'border-primary bg-primary-soft text-primary' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'"
                        [attr.aria-pressed]="statusFilter === 'all'" [disabled]="loading" (click)="statusFilter = 'all'">
                    Tutti <span class="tabular-nums opacity-70">{{ filterCount('all') }}</span>
                </button>
                <button *ngFor="let status of statuses" type="button"
                        class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold transition"
                        [ngClass]="statusFilter === status.id ? 'border-primary bg-primary-soft text-primary' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'"
                        [attr.aria-pressed]="statusFilter === status.id" [disabled]="loading" (click)="statusFilter = status.id">
                    <i class="h-2 w-2 rounded-full"
                       [ngClass]="{'bg-emerald-500': status.id === 'paid', 'bg-amber-500': status.id === 'verifyingPayment', 'bg-red-500': status.id === 'pendingPayment'}"></i>
                    {{ status.short }} <span class="tabular-nums opacity-70">{{ filterCount(status.id) }}</span>
                </button>
                <button type="button"
                        class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold transition"
                        [ngClass]="statusFilter === 'noMembership' ? 'border-primary bg-primary-soft text-primary' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'"
                        [attr.aria-pressed]="statusFilter === 'noMembership'" [disabled]="loading" (click)="statusFilter = 'noMembership'">
                    Non tesserati <span class="tabular-nums opacity-70">{{ filterCount('noMembership') }}</span>
                </button>
            </div>
        </div>

        <!-- Athletes -->
        <div class="overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-sm">
            <div class="overflow-x-auto">
                <table class="w-full border-collapse text-sm">
                    <thead>
                        <tr class="border-b-2 border-slate-100 bg-slate-50">
                            <th class="whitespace-nowrap px-5 py-4 text-left text-xs font-bold uppercase tracking-wide !text-slate-500">Atleta</th>
                            <th class="whitespace-nowrap px-5 py-4 text-left text-xs font-bold uppercase tracking-wide !text-slate-500">Contatti</th>
                            <th class="whitespace-nowrap px-5 py-4 text-left text-xs font-bold uppercase tracking-wide !text-slate-500">Pagamento</th>
                            <th class="whitespace-nowrap px-5 py-4 text-left text-xs font-bold uppercase tracking-wide !text-slate-500">Tesseramento</th>
                            <th *ngIf="primaryDocumentExists" class="whitespace-nowrap px-5 py-4 text-left text-xs font-bold uppercase tracking-wide !text-slate-500">Documento</th>
                            <th class="w-px px-5 py-4"><span class="sr-only">Azioni</span></th>
                        </tr>
                    </thead>

                    <tbody *ngIf="loading">
                        <tr *ngFor="let row of skeletonRows" class="border-b border-slate-100 last:border-0">
                            <td class="px-5 py-4">
                                <div class="flex items-center gap-3">
                                    <span class="h-10 w-10 shrink-0 animate-pulse rounded-full bg-slate-100"></span>
                                    <div class="flex flex-col gap-1.5">
                                        <span class="h-3.5 w-32 animate-pulse rounded bg-slate-100"></span>
                                        <span class="h-3 w-24 animate-pulse rounded bg-slate-100"></span>
                                    </div>
                                </div>
                            </td>
                            <td class="px-5 py-4"><span class="block h-3.5 w-40 animate-pulse rounded bg-slate-100"></span></td>
                            <td class="px-5 py-4"><span class="block h-6 w-24 animate-pulse rounded-full bg-slate-100"></span></td>
                            <td class="px-5 py-4"><span class="block h-3.5 w-28 animate-pulse rounded bg-slate-100"></span></td>
                            <td *ngIf="primaryDocumentExists" class="px-5 py-4"><span class="block h-3.5 w-28 animate-pulse rounded bg-slate-100"></span></td>
                            <td class="px-5 py-4"><span class="block h-8 w-8 animate-pulse rounded-lg bg-slate-100"></span></td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!loading">
                        <tr *ngFor="let enrollment of filteredEnrollments; trackBy: trackByAthlete"
                            class="border-b border-slate-100 transition-colors last:border-0 hover:bg-slate-50/70">
                            <td class="px-5 py-3.5">
                                <div class="flex min-w-0 items-center gap-3">
                                    <app-identity-avatar
                                        [imageUrl]="enrollment.athlete?.image"
                                        [initials]="initials(enrollment)"
                                        [colorKey]="enrollment.athleteId || ''"
                                    ></app-identity-avatar>
                                    <div class="min-w-0">
                                        <a class="block truncate font-semibold text-slate-900 no-underline hover:text-primary"
                                           [routerLink]="['/companies/athlete', enrollment.athleteId]">
                                            {{ enrollment.athlete?.lastName }} {{ enrollment.athlete?.firstName }}
                                        </a>
                                        <span class="block truncate font-mono text-xs uppercase text-slate-400">{{ enrollment.athlete?.fiscalCode || '—' }}</span>
                                    </div>
                                </div>
                            </td>
                            <td class="px-5 py-3.5">
                                <div class="flex flex-col gap-0.5 text-[0.82rem]">
                                    <a *ngIf="enrollment.athlete?.phone" class="inline-flex items-center gap-1.5 whitespace-nowrap text-slate-700 no-underline hover:text-primary"
                                       [href]="'tel:' + enrollment.athlete?.phone">
                                        <i class="bi bi-telephone text-slate-400" aria-hidden="true"></i>{{ enrollment.athlete?.phone }}
                                    </a>
                                    <a *ngIf="enrollment.athlete?.email" class="inline-flex max-w-[16rem] items-center gap-1.5 truncate text-slate-700 no-underline hover:text-primary"
                                       [href]="'mailto:' + enrollment.athlete?.email">
                                        <i class="bi bi-envelope text-slate-400" aria-hidden="true"></i><span class="truncate">{{ enrollment.athlete?.email }}</span>
                                    </a>
                                    <span *ngIf="!enrollment.athlete?.phone && !enrollment.athlete?.email" class="text-slate-400">—</span>
                                </div>
                            </td>
                            <td class="px-5 py-3.5">
                                <span class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-bold ring-1 ring-inset"
                                      [ngClass]="statusClasses(displayStatus(enrollment))">
                                    <i class="bi" [ngClass]="statusIcon(displayStatus(enrollment))" aria-hidden="true"></i>
                                    {{ statusLabel(displayStatus(enrollment)) }}
                                </span>
                                <span class="mt-1 flex items-center gap-1 text-xs tabular-nums text-slate-500"><i class="bi bi-wallet2 text-slate-400" aria-hidden="true"></i>{{ formatEuro(amount(enrollment)) }}</span>
                            </td>
                            <td class="px-5 py-3.5">
                                <span class="inline-flex items-center gap-1.5 whitespace-nowrap text-[0.82rem] font-semibold"
                                      [ngClass]="hasMembership(enrollment) ? 'text-emerald-700' : 'text-red-600'">
                                    <i class="bi" [ngClass]="hasMembership(enrollment) ? 'bi-patch-check-fill' : 'bi-patch-exclamation'" aria-hidden="true"></i>
                                    {{ hasMembership(enrollment) ? 'Tesserato' : 'Non tesserato' }}
                                </span>
                                <span class="mt-0.5 block whitespace-nowrap text-xs text-slate-400">{{ membershipText(enrollment) }}</span>
                            </td>
                            <td *ngIf="primaryDocumentExists" class="px-5 py-3.5">
                                <span class="whitespace-nowrap text-[0.82rem] font-semibold"
                                      [ngClass]="documentClasses(documentState(enrollment).status)">
                                    {{ documentState(enrollment).text }}
                                </span>
                            </td>
                            <td class="px-5 py-3.5 text-right">
                                <a class="btn welldone-btn-gray inline-flex items-center" title="Apri scheda atleta"
                                   [routerLink]="['/companies/athlete', enrollment.athleteId]">
                                    <i class="bi bi-arrow-right" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>

                        <tr *ngIf="!filteredEnrollments.length">
                            <td [attr.colspan]="primaryDocumentExists ? 6 : 5" class="px-5 py-12 text-center">
                                <ng-container *ngIf="enrollments.length; else noEnrollments">
                                    <p class="m-0 text-slate-500">Nessun atleta corrisponde ai filtri.</p>
                                    <button type="button" class="btn btn-reset-link mt-2" (click)="search = ''; statusFilter = 'all'">Azzera filtri</button>
                                </ng-container>
                                <ng-template #noEnrollments>
                                    <i class="bi bi-people mb-2 block text-3xl text-slate-300" aria-hidden="true"></i>
                                    <p class="m-0 font-semibold text-slate-700">Ancora nessun iscritto in questa categoria</p>
                                    <p class="m-0 mt-1 text-sm text-slate-400">Gli atleti compariranno qui appena completano l'iscrizione.</p>
                                </ng-template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <p *ngIf="!loading && filteredEnrollments.length" class="mt-3 text-right text-xs text-slate-400">
            {{ filteredEnrollments.length }} di {{ enrollments.length }} atleti
        </p>
        </ng-container>

        <!-- Convocations -->
        <ng-container *ngIf="tab === 'convocations'">
            <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
                <div class="inline-flex rounded-xl bg-slate-100 p-1" role="group" aria-label="Periodo">
                    <button type="button"
                            class="rounded-lg border-0 px-3.5 py-1.5 text-sm font-semibold transition"
                            [ngClass]="convocationPeriod === 'upcoming' ? 'bg-white text-slate-900 shadow-sm' : 'bg-transparent text-slate-500 hover:text-slate-800'"
                            [attr.aria-pressed]="convocationPeriod === 'upcoming'" (click)="convocationPeriod = 'upcoming'">
                        Prossime <span class="tabular-nums opacity-60">{{ upcomingConvocations.length }}</span>
                    </button>
                    <button type="button"
                            class="rounded-lg border-0 px-3.5 py-1.5 text-sm font-semibold transition"
                            [ngClass]="convocationPeriod === 'past' ? 'bg-white text-slate-900 shadow-sm' : 'bg-transparent text-slate-500 hover:text-slate-800'"
                            [attr.aria-pressed]="convocationPeriod === 'past'" (click)="convocationPeriod = 'past'">
                        Passate <span class="tabular-nums opacity-60">{{ pastConvocations.length }}</span>
                    </button>
                </div>
                <button type="button" class="btn btn-primary inline-flex items-center gap-1.5" (click)="openNewConvocation()">
                    <i class="bi bi-plus-lg" aria-hidden="true"></i>
                    Nuova convocazione
                </button>
            </div>

            <!-- Loading -->
            <div *ngIf="loadingConvocations" class="flex flex-col gap-3" aria-hidden="true">
                <div *ngFor="let i of [1, 2, 3]" class="flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
                    <span class="h-14 w-14 shrink-0 animate-pulse rounded-xl bg-slate-100"></span>
                    <div class="flex flex-1 flex-col gap-2">
                        <span class="h-4 w-1/3 animate-pulse rounded bg-slate-100"></span>
                        <span class="h-3 w-1/2 animate-pulse rounded bg-slate-100"></span>
                    </div>
                    <span class="h-6 w-20 animate-pulse rounded-full bg-slate-100"></span>
                </div>
            </div>

            <div *ngIf="!loadingConvocations && convocationsError"
                 class="flex flex-col items-center rounded-2xl border-2 border-dashed border-slate-200 px-6 py-10 text-center">
                <i class="bi bi-exclamation-triangle mb-2 text-3xl text-amber-500" aria-hidden="true"></i>
                <p class="m-0 font-semibold text-slate-700">Impossibile caricare le convocazioni</p>
                <button type="button" class="btn btn-reset-link mt-2" (click)="loadConvocations(category?.id || '')">Riprova</button>
            </div>

            <div *ngIf="!loadingConvocations && !convocationsError && !visibleConvocations.length"
                 class="flex flex-col items-center rounded-2xl border-2 border-dashed border-slate-200 px-6 py-10 text-center">
                <i class="bi bi-calendar2-x mb-2 text-3xl text-slate-300" aria-hidden="true"></i>
                <p class="m-0 font-semibold text-slate-700">
                    {{ convocationPeriod === 'upcoming' ? 'Nessuna convocazione in programma' : 'Nessuna convocazione passata' }}
                </p>
                <p class="m-0 mt-1 text-sm text-slate-400">
                    {{ convocations.length ? 'Prova a guardare ' + (convocationPeriod === 'upcoming' ? 'quelle passate.' : 'quelle in programma.') : 'Ancora nessuna convocazione per questa categoria.' }}
                </p>
                <button *ngIf="convocationPeriod === 'upcoming'" type="button" class="btn btn-primary mt-4" (click)="openNewConvocation()">Crea convocazione</button>
            </div>

            <ul *ngIf="!loadingConvocations && !convocationsError && visibleConvocations.length" class="m-0 flex list-none flex-col gap-3 pl-0">
                <li *ngFor="let convocation of visibleConvocations; trackBy: trackByConvocation"
                    class="overflow-hidden rounded-2xl border bg-white shadow-sm transition"
                    [ngClass]="expandedConvocationId === convocation.id ? 'border-primary' : 'border-slate-100'">
                    <button type="button"
                            class="flex w-full items-center gap-4 border-0 bg-transparent p-4 text-left hover:bg-slate-50/70"
                            [attr.aria-expanded]="expandedConvocationId === convocation.id"
                            (click)="toggleConvocation(convocation)">
                        <span class="flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-xl leading-none"
                              [ngClass]="convocationPeriod === 'upcoming' ? 'bg-primary-soft text-primary' : 'bg-slate-100 text-slate-500'">
                            <span class="text-xl font-bold tabular-nums">{{ convocationDay(convocation) }}</span>
                            <span class="mt-0.5 text-[0.68rem] font-bold uppercase">{{ convocationMonth(convocation) }}</span>
                        </span>
                        <span class="min-w-0 flex-1">
                            <span class="block truncate font-semibold text-slate-900">{{ convocation.title }}</span>
                            <span class="mt-0.5 block truncate text-[0.82rem] capitalize text-slate-500">{{ convocationWhen(convocation) }}</span>
                            <span class="mt-0.5 flex items-center gap-1 truncate text-[0.82rem] text-slate-500">
                                <i class="bi bi-geo-alt text-slate-400" aria-hidden="true"></i>
                                <span class="truncate">{{ convocation.location }}<ng-container *ngIf="convocation.city">, {{ convocation.city }}</ng-container></span>
                            </span>
                        </span>
                        <span class="hidden shrink-0 flex-col items-end gap-1.5 sm:flex">
                            <span class="inline-flex rounded-full px-2.5 py-1 text-xs font-bold ring-1 ring-inset"
                                  [ngClass]="convocationStatusClasses(convocation.status)">{{ convocation.status }}</span>
                            <span class="inline-flex items-center gap-1 text-xs text-slate-500">
                                <i class="bi bi-people" aria-hidden="true"></i>
                                {{ convocation.users?.length || 0 }} convocati
                            </span>
                        </span>
                        <i class="bi shrink-0 text-slate-400" [ngClass]="expandedConvocationId === convocation.id ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
                    </button>

                    <div *ngIf="expandedConvocationId === convocation.id" class="border-t border-slate-100 bg-slate-50/50 px-4 py-4 sm:px-5">
                        <div class="mb-3 flex flex-wrap items-center gap-2 sm:hidden">
                            <span class="inline-flex rounded-full px-2.5 py-1 text-xs font-bold ring-1 ring-inset"
                                  [ngClass]="convocationStatusClasses(convocation.status)">{{ convocation.status }}</span>
                            <span class="text-xs text-slate-500">{{ convocation.users?.length || 0 }} convocati</span>
                        </div>
                        <p *ngIf="convocation.description" class="m-0 mb-3 whitespace-pre-line text-sm text-slate-700">{{ convocation.description }}</p>
                        <p class="m-0 mb-4 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-slate-600">
                            <span class="inline-flex items-center gap-1.5">
                                <i class="bi bi-geo-alt text-slate-400" aria-hidden="true"></i>
                                {{ convocation.address }}<ng-container *ngIf="convocation.city">, {{ convocation.city }}</ng-container><ng-container *ngIf="convocation.province"> ({{ convocation.province }})</ng-container>
                            </span>
                            <a *ngIf="convocation.linkPosition" class="inline-flex items-center gap-1 font-semibold text-primary no-underline hover:underline"
                               [href]="convocation.linkPosition" target="_blank" rel="noopener">
                                Apri mappa <i class="bi bi-box-arrow-up-right text-xs" aria-hidden="true"></i>
                            </a>
                        </p>

                        <div class="mb-4 flex flex-wrap gap-2">
                            <a class="btn btn-primary inline-flex items-center gap-1.5"
                               [routerLink]="['/companies/subscriptions/category', category?.id, 'convocations', convocation.id]">
                                <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i>
                                Apri convocazione
                            </a>
                        </div>

                        <h4 class="m-0 mb-2 text-xs font-bold uppercase tracking-wide text-slate-500">
                            Convocati ({{ convocation.users?.length || 0 }} su {{ stats.total }} iscritti)
                        </h4>
                        <div *ngIf="convocatedAthletes(convocation).length; else noConvocated" class="flex flex-wrap gap-1.5">
                            <a *ngFor="let athlete of convocatedAthletes(convocation)"
                               class="inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold no-underline"
                               [ngClass]="athlete.enrolled ? 'border-slate-200 bg-white text-slate-700 hover:border-primary hover:text-primary' : 'pointer-events-none border-dashed border-slate-200 bg-transparent text-slate-400'"
                               [routerLink]="athlete.enrolled ? ['/companies/athlete', athlete.id] : null">
                                {{ athlete.name }}
                            </a>
                        </div>
                        <ng-template #noConvocated>
                            <p class="m-0 text-sm text-slate-400">Nessun atleta convocato.</p>
                        </ng-template>
                    </div>
                </li>
            </ul>
        </ng-container>
    </ng-container>
</div>

<app-mister-convocation-form
    [isOpen]="convocationFormOpen"
    [convocation]="null"
    [defaultCategoryId]="category?.id"
    (closed)="convocationFormOpen = false"
    (saved)="onConvocationCreated($event)"
></app-mister-convocation-form>
